import type { AuthProvider } from 'react-admin';
import { API_URL, STAFF_STORAGE_KEY, TOKEN_STORAGE_KEY } from '../config';

interface LoginResponse {
  accessToken: string;
  expiresAt: string;
  staff: {
    id: string;
    email: string;
    displayName: string;
    role: 'admin' | 'moderator' | 'support';
  };
}

export const authProvider: AuthProvider = {
  async login({ username, password }: { username: string; password: string }) {
    const res = await fetch(`${API_URL}/staff/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: username, password }),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error((data as { message?: string }).message ?? 'Неверный email или пароль');
    }
    const data = (await res.json()) as LoginResponse;
    localStorage.setItem(TOKEN_STORAGE_KEY, data.accessToken);
    localStorage.setItem(STAFF_STORAGE_KEY, JSON.stringify(data.staff));
  },

  async logout() {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    localStorage.removeItem(STAFF_STORAGE_KEY);
  },

  async checkAuth() {
    if (!localStorage.getItem(TOKEN_STORAGE_KEY)) {
      throw new Error('Не залогинен');
    }
  },

  async checkError(error: { status?: number }) {
    if (error.status === 401 || error.status === 403) {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      localStorage.removeItem(STAFF_STORAGE_KEY);
      throw new Error('Сессия истекла, войдите заново');
    }
  },

  async getIdentity() {
    const raw = localStorage.getItem(STAFF_STORAGE_KEY);
    if (!raw) throw new Error('Нет staff в storage');
    const staff = JSON.parse(raw) as LoginResponse['staff'];
    return { id: staff.id, fullName: staff.displayName };
  },

  async getPermissions() {
    const raw = localStorage.getItem(STAFF_STORAGE_KEY);
    if (!raw) return null;
    const staff = JSON.parse(raw) as LoginResponse['staff'];
    return staff.role;
  },
};
